import { render, staticRenderFns } from "./FlashpayTransferMoney.vue?vue&type=template&id=0dcd7e1b&scoped=true"
import script from "./FlashpayTransferMoney.vue?vue&type=script&lang=js"
export * from "./FlashpayTransferMoney.vue?vue&type=script&lang=js"
import style0 from "./FlashpayTransferMoney.vue?vue&type=style&index=0&id=0dcd7e1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcd7e1b",
  null
  
)

export default component.exports